export default __webpack_public_path__ + "9f1092d036076c58004147643fcedf04.otf";